import React , {useState, useEffect} from 'react'
import Button from './Button';
import * as Api from "../../api";
import ModalWhatsAppCode from '../ModalWhatsAppCode';
import FeatureFlags, { WHATSAPP_VERIFICATION } from '../../services/FeatureFlags';

const ButtonAcceptContrato =  ({ item , infcontrato}) => {

    const [actionresult,setActionResult] = useState({loader :  false,msg: '',class: '',codigoresult: -1});
    const [showModal, setShowModal] = useState(false);
    const [whatsappVerifyEnabled, setWhatsappVerifyEnabled] = useState(false);

    useEffect(() => {
        let mounted = true;
        FeatureFlags.load().then(() => {
            if (mounted) {
                setWhatsappVerifyEnabled(FeatureFlags.isEnabled(WHATSAPP_VERIFICATION));
            }
        });
        return () => { mounted = false };
    }, []);

    const handleAccpetContrato = async () => {

        setShowModal(false);
        setActionResult(actionresult => ({...actionresult,...{loader: !actionresult.loader, msg: ''}}));

        const data = await Api.ActionAcceptarContrato({
            'campana' : infcontrato.CIA,
            'parque' : infcontrato.PARQUE,
            'codigo' : infcontrato.SERIE,
            'numero' : infcontrato.CONTRATO
         });

        if (typeof data !== 'undefined') {
            const {  status , result } = data;

            if (status === 'success') {

                if(result == 1) {
                    setActionResult(actionresult => ({...actionresult,...{msg: 'Proceso finalizado exitosamente.', class: 'badge badge-success' , codigoresult: result}}));
                    localStorage.setItem('update',1);

                   setTimeout(function(){   window.location.reload() }, 3000);

                } else {
                    setActionResult(actionresult => ({...actionresult,...{loader: !actionresult.loader , msg: 'Ha occurrido un Error para aceptar el contrato.', class: 'badge badge-danger' , codigoresult: result}}));
                }
            } else {
                console.log(result);
                setActionResult(actionresult => ({...actionresult,...{loader: !actionresult.loader, msg: 'Ha occurrido un Error inesperado.', class: 'badge badge-danger' , codigoresult: -99}}));
            }
        } else {
            setActionResult(actionresult => ({...actionresult,...{loader: !actionresult.loader}}));
          }

    }

    // Con el flag `whatsapp_verification` deshabilitado se acepta el contrato
    // directamente, sin abrir el modal de código.
    const handleClickAceptar = () => {
        if (whatsappVerifyEnabled) {
            setShowModal(true);
        } else {
            handleAccpetContrato();
        }
    }

    return (
        <><span className={actionresult.class}>{actionresult.msg}</span><br />
        {actionresult.codigoresult == 1 ? <>Se redireccionará en 3 segundos . . .</> : <></>}
        <Button loader={actionresult.loader} handleLogin={handleClickAceptar} name="Aceptar Contrato" classes="bt-ms _bt-green" type="button" />
        {whatsappVerifyEnabled && <ModalWhatsAppCode
            isOpen={showModal}
            toggle={() => setShowModal(false)}
            onVerified={handleAccpetContrato}
        />}</>
    )
}

export default ButtonAcceptContrato